export default __webpack_public_path__ + "static/media/savings_gimmicky.720d3bb2.svg";